/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const getJpdViewsServicePathPrefix = (): string => '/gateway/api/jpd/views';
